<template>
  <div class="rules">
    <div class="title-container">
      <div class="item-line item-left">
        <div class="line"></div>
        <div class="dot"></div>
      </div>
      <div class="title">活动规则</div>
      <div class="item-line item-right">
        <div class="dot"></div>
        <div class="line"></div>
      </div>
    </div>
    <div class="rule-item" v-for="(item, index) in rules" :key="index">
      <div class="item-text">{{ item.title }}</div>
      <div class="item-desc" v-html="item.content"></div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    rules: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {}
  },
  filters: {
    filterIndex(index) {
      index = index + 1
      return index > 9 ? index : '0' + index
    }
  },
  created() {},
  methods: {}
}
</script>
<style lang="scss" scoped>
.rules {
  margin-top: 25px;
  padding: 0px 30px;
  .title-container {
    margin-bottom: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    .item-line {
      display: flex;
      align-items: center;
      justify-content: center;
      .line {
        width: 63px;
        height: 1px;
        background: linear-gradient(
          90deg,
          rgba(255, 255, 255, 0),
          rgba(255, 255, 255, 1)
        );
      }
      .dot {
        width: 3px;
        height: 3px;
        background-color: #fff;
        transform: rotate(45deg);
      }
    }
    .item-right {
      .line {
        background: linear-gradient(
          90deg,
          rgba(255, 255, 255, 1),
          rgba(255, 255, 255, 0)
        );
      }
    }
    .title {
      margin: 0px 10px;
      font-weight: bold;
      font-size: 20px;
      color: #ffffff;
      line-height: 28px;
    }
  }
  .rule-item {
    margin-bottom: 19px;
    .item-text {
      font-weight: bold;
      font-size: 15px;
      color: #ffffff;
      line-height: 20px;
      margin-bottom: 6px;
    }
    .item-desc {
      font-size: 12px;
      color: rgba(255, 255, 255, 0.8);
      line-height: 17px;
    }
  }
  .rule-item:last-child {
    margin-bottom: 0px;
  }
}
</style>
